import { Component, OnInit, Renderer2, ViewChild, ElementRef, Input } from '@angular/core';
import { InitService } from '../../services/init.service';
import { StoreServiceLibrary } from '@wearenovae/novae-core-services';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-asked-questions',
  templateUrl: './asked-questions.component.html',
  styleUrls: ['./asked-questions.component.scss']
})
export class AskedQuestionsComponent implements OnInit {

  config: any;
  showComponent = false;

  public video: string;
  public open: boolean;
  public play: boolean;

  constructor(
    private renderer: Renderer2, private el: ElementRef,
    private init: InitService, private store: StoreServiceLibrary,
    public translate: TranslateService
  ) {
  }

  contentCard2 = [
    {
      titulo: 'Miles Care Premium',
      precioUno: '99',
      precioDos: '1,000',
      precioTres: '600',
      precioCuatro: '75',
      precioCinco: '100,000',
      precioSeis: '500'
    },
    {
      titulo: 'Miles Care Exclusive',
      precioUno: '179',
      precioDos: '2,000',
      precioTres: '800',
      precioCuatro: '100',
      precioCinco: '250,000',
      precioSeis: '1,000'
    },
    {
      titulo: 'Miles Care Privilege',
      precioUno: '249',
      precioDos: '3,000',
      precioTres: '2,000',
      precioCuatro: '200',
      precioCinco: '2,000,000',
      precioSeis: '3,000'
    }
  ];

  ngOnInit(): void {
    this.init.isInitializedBrand.subscribe((init) => {
      if (init) {
        this.translate.currentLang
        // let configToRender = {"asked-questions":{"title":{"en":"Frequently Asked Questions","es":"Preguntas frecuentes"},"description":{"en":"<strong>Got a question?</strong><br>Reach out to alle and get answers 24/7. <a href=\"\">Just click here.</a>","es":"<strong>¿Tienes alguna pregunta?</strong><br>Comunícate con todos y obtén respuestas las 24 horas del día, los 7 días de la semana. <a href=\"\">Simplemente haga clic aquí.</a>"},"tabs":[{"title":{"en":"The program","es":"El programa"},"questionsPanel":[{"question":{"en":"What is <strong>My Rewards</strong>?","es":"¿Qué es <strong>My Rewards</strong>?"},"answer":{"paragraphs":[{"en":"Let's get you started! Open the <strong> My Rewards app</strong> and login with your existing credentials.","es":"¡Vamos a empezar! Abra la aplicación <strong> My Rewards</strong> e inicie sesión con sus credenciales existentes."},{"en":"Once you're logged in, please follow these steps","es":"Una vez que haya iniciado sesión, siga estos pasos"}],"steps":[{"en":"Tap the Voyage button from the main navigation screen","es":"Toque el botón Voyage en la pantalla de navegación principal"},{"en":"Then, select the Hotels option.","es":"Luego, seleccione la opción Hoteles."},{"en":"Enter the details of your trip, like destination, checkin and checkout dates, number of rooms and passengers, and touch the Search button","es":"Ingrese los detalles de su viaje, como destino, fechas de entrada y salida, número de habitaciones y pasajeros, y toque el botón Buscar"},{"en":"Select your choice from the search results and press Book when you are ready","es":"Seleccione su elección de los resultados de búsqueda y presione Reservar cuando esté listo"},{"en":"Review the details of your reservation to ensure that the information is accurate","es":"Revise los detalles de su reserva para asegurarse de que la información sea precisa"},{"en":"Enter each passenger information and touch the Continue button to proceed to checkout","es":"Ingrese la información de cada pasajero y toque el botón Continuar para proceder al pago"},{"en":"Enter each passenger's contact information, and press Continue","es":"Ingrese la información de contacto de cada pasajero y presione Continuar"},{"en":"Select the amount of miles you wish to apply to your purchase and confirm the transaction","es":"Seleccione la cantidad de millas que desea aplicar a su compra y confirme la transacción"}],"paragraphFooter":[{"en":"<strong>All set! Better pack your bags! </strong>","es":"<strong>¡Todo listo! ¡Mejor empaca tus maletas! </strong>"}],"videos":[{"img":{"en":"/assets/images/myrewards-miles/help-center2.png","es":"/assets/images/myrewards-miles/help-center2.png"},"url":{"en":"https://player.vimeo.com/external/462698340.hd.mp4?s=4831102565ac2c2212934a453d5bd09530ff23c1&profile_id=175","es":"https://player.vimeo.com/external/462698340.hd.mp4?s=4831102565ac2c2212934a453d5bd09530ff23c1&profile_id=175"},"title":{"en":"<strong>Booking travel</strong>","es":"<strong>Reservar viajes</strong>"},"description":{"en":"To learn more, check out this video","es":"Para obtener más información, mira este video"}}]}}]}]}};
        let configToRender = this.store.getItemFromStorage('CONFIG-HELP') || false;
        if (configToRender) {
          let helpCenter = configToRender['asked-questions'] || false;
          if (helpCenter) {
            this.config = configToRender['asked-questions'];
            this.showComponent = true;
          } else {
            this.showComponent = false;
          }
        } else {
          this.showComponent = false;
        }

      }
    });

    const bar = this.el.nativeElement.querySelector('mat-ink-bar');
    bar.style.maxWidth = "143px";
  }
  

  openModal(urlVideo) {
    this.open = true;
    this.video = urlVideo;
    const elementVideo = this.el.nativeElement.querySelector('video');
    elementVideo.play();
  }

  closeModal() {
    this.open = false;
    const elementVideo = this.el.nativeElement.querySelector('video');
    elementVideo.pause();
    elementVideo.currentTime = 0;
    this.play = false;
  }

  playVideo() {
    this.play = true;
    const elementVideo = this.el.nativeElement.querySelector('video');
    elementVideo.play();
  }

  onTabChanged($event){
    console.log($event.index);
    const bar = this.el.nativeElement.querySelector('mat-ink-bar');
    
    if($event.index == 0){
      bar.style.maxWidth = "143px";
    }else{
      setTimeout(function(){
        const atr = bar.getAttribute("style");
        const atr1 = atr.substring(atr.length - 6, atr.length -1);
        bar.style.maxWidth = atr1;
      }, 100)
    }
    
    
    
    
  }

}
